


export default function BackIconBig({ className }) {
    return <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="32" y="32" width="32" height="32" rx="16" transform="rotate(-180 32 32)" fill="#F6F6F6" />
        <path d="M8.54038 15.5404C8.28654 15.7942 8.28654 16.2058 8.54038 16.4596L12.677 20.5962C12.9308 20.85 13.3424 20.85 13.5962 20.5962C13.85 20.3424 13.85 19.9308 13.5962 19.677L9.91924 16L13.5962 12.323C13.85 12.0692 13.85 11.6576 13.5962 11.4038C13.3424 11.15 12.9308 11.15 12.677 11.4038L8.54038 15.5404ZM23 16V15.35L9 15.35V16V16.65H23V16Z" fill="black" />
    </svg>
}